import type { RouteLocation } from 'vue-router';

// Always uppercase serialNumber because backend needs it for smth
export const uppercaseSerialNumber = (route: RouteLocation) => {
  const { serialNumber } = route.params;
  const uppercaseSerialNumber = String(serialNumber).toUpperCase();

  if (serialNumber !== uppercaseSerialNumber) {
    return {
      name: route.name as string,
      params: {
        ...route.params,
        serialNumber: uppercaseSerialNumber,
      },
      hash: route.hash,
      query: { ...route.query },
      replace: true,
    };
  }
};
